import { render, staticRenderFns } from "./ChangeAddressModal.vue?vue&type=template&id=31e2e55c&scoped=true"
import script from "./ChangeAddressModal.vue?vue&type=script&lang=js"
export * from "./ChangeAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2e55c",
  null
  
)

export default component.exports